import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ProjectSection from "./ProjectSection";
import { useLanguage } from "../../context/LanguageContext";

const ProjectPage: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    document.title = `${t.nav.projects} | ${t.company.name}`;
  }, [t.nav.projects, t.company.name]);

  return (
    <Fragment>
      <div className="service-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={t.nav.projects} pagesub={t.nav.projects} />
            <ProjectSection />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ProjectPage;
